import zh from '@/locales/zh';
import en from '@/locales/en';
export default { zh, en };